import { render, staticRenderFns } from "./AddToFavourite.vue?vue&type=template&id=4b435b34&"
import script from "./AddToFavourite.ts?vue&type=script&lang=ts&"
export * from "./AddToFavourite.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports